import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MP',
    name: 'María P.',
    city: 'Buenos Aires 🇦🇷',
    text: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso.'
  }, {
    initials: 'CG',
    name: 'Claudia G.',
    city: 'Córdoba 🇦🇷',
    text: 'Tres alumnos de inicial que estaban estancados mejoraron su alineación en el primer mes con el Tomo 2.'
  }, {
    initials: 'FR',
    name: 'Federico R.',
    city: 'Rosario 🇦🇷',
    text: 'Antes tardaba 1 hora armando una secuencia. Ahora son 5 minutos.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    city: 'Mendoza 🇦🇷',
    text: 'El Bonus de Anatomía cambió cómo corrijo a mis alumnos. Ahora sé exactamente qué decir y por qué.'
  }, {
    initials: 'DA',
    name: 'Diego A.',
    city: 'Santa Fe 🇦🇷',
    text: 'El Manual de Modificaciones me salvó con una alumna embarazada. Supe exactamente qué hacer en cada postura.'
  }, {
    initials: 'CR',
    name: 'Claudia R.',
    city: 'Tucumán 🇦🇷',
    text: 'Energía Blindada cambió mi relación con la enseñanza. Termino las clases con energía, no agotada.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-217">
      <div className="max-w-6xl mx-auto" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-oscuro mb-4" data-id="element-220">
            Lo que dicen los profesores
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-2xl font-bold text-dorado" data-id="element-221">
            4.9/5 ⭐
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-222">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-hueso p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-223">
              <div className="flex items-center gap-4 mb-3" data-id="element-224">
                <div className="w-12 h-12 bg-terracota/10 text-terracota rounded-full flex items-center justify-center font-bold text-lg" data-id="element-225">
                  {t.initials}
                </div>
                <div data-id="element-226">
                  <p className="font-bold text-oscuro" data-id="element-227">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-228">{t.city}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3" data-id="element-229">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-dorado text-dorado" data-id="element-230" />)}
              </div>
              <p className="text-gray-700 italic leading-relaxed" data-id="element-231">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}